function RxPlayback(props) {

    let queryString = window.location.search.substring(1)
    let params = new URLSearchParams(queryString)
    let rxMAC = params.get("a")
    console.log('url include Rx is '+ rxMAC)
    console.log('PUBLIC_URL IS '+ process.env.PUBLIC_URL)
    window.location.href = process.env.PUBLIC_URL + '/playback.html?a='+rxMAC;
    return null
}

export default RxPlayback
